"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostItemSkeleton = void 0;
const react_1 = __importDefault(require("react"));
const react_loading_skeleton_1 = __importDefault(require("react-loading-skeleton"));
const scale_1 = require("../../utils/scale");
const PostItemSkeleton = () => {
    return (react_1.default.createElement("div", { className: "article-loading" },
        react_1.default.createElement(react_loading_skeleton_1.default, { width: (0, scale_1.scale)(42), height: (0, scale_1.scale)(42), circle: true }),
        react_1.default.createElement("div", { className: "article-loading__content" },
            react_1.default.createElement(react_loading_skeleton_1.default, { height: (0, scale_1.scale)(21), borderRadius: (0, scale_1.moderateScale)(16) }),
            react_1.default.createElement(react_loading_skeleton_1.default, { height: (0, scale_1.scale)(162), borderRadius: (0, scale_1.moderateScale)(16) }))));
};
exports.PostItemSkeleton = PostItemSkeleton;
const PostSkeleton = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("style", null, `
            @keyframes react-loading-skeleton {
              100% {
                transform: translateX(100%);
              }
            }
            
            .react-loading-skeleton {
              --base-color: #ebebeb;
              --highlight-color: #f5f5f5;
              --animation-duration: 1.5s;
              --animation-direction: normal;
              --pseudo-element-display: block; /* Enable animation */
            
              background-color: var(--base-color);
            
              width: 100%;
              border-radius: 0.25rem;
              display: inline-flex;
              line-height: 1;
            
              position: relative;
              user-select: none;
              overflow: hidden;
              transform: translateZ(0);
            }
            
            .react-loading-skeleton::after {
              content: ' ';
              display: var(--pseudo-element-display);
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 100%;
              background-repeat: no-repeat;
              background-image: linear-gradient(
                90deg,
                var(--base-color),
                var(--highlight-color),
                var(--base-color)
              );
              transform: translateX(-100%) translateZ(0);
            
              animation-name: react-loading-skeleton;
              animation-direction: var(--animation-direction);
              animation-duration: var(--animation-duration);
              animation-timing-function: ease-in-out;
              animation-iteration-count: infinite;
            }
            
            @media (prefers-reduced-motion) {
              .react-loading-skeleton {
                --pseudo-element-display: none; /* Disable animation */
              }
            }

            .article-loading-container {
              display: flex;
              flex-direction: column;
              gap: 0.75rem;
              padding: 0.75rem 1rem;
            }

            .article-loading {
              display: flex;
              gap: 0.75rem;
            }

            .article-loading__content {
              flex: 1;
              display: flex;
              flex-direction: column;
              gap: 0.5rem;
            }
            
          `),
        react_1.default.createElement("div", { className: "article-loading-container" }, new Array(5).fill(0).map((_, idx) => {
            return react_1.default.createElement(exports.PostItemSkeleton, { key: idx });
        }))));
};
exports.default = PostSkeleton;
